// API utility functions for backend communication
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001';

/**
 * Fetch all products from the backend
 * @returns {Promise<Array>} Array of products
 */
export const fetchProducts = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/products`);
        if (!response.ok) {
            throw new Error(`Failed to fetch products: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching products:', error);
        throw error;
    }
};



/**
 * Stream deep analysis events
 * @param {Array} selectedProducts - Array of product objects with product_id
 * @returns {Promise<Response>} Fetch response for streaming
 */
export const streamDeepAnalysis = async (selectedProducts) => {
    try {
        const productIds = selectedProducts.map(p => p.product_id);
        return await fetch(`${API_BASE_URL}/deep-analysis/stream`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'text/event-stream',
            },
            body: JSON.stringify({
                selected_products: productIds,
                analysis_type: 'deep_analysis'
            })
        });
    } catch (error) {
        console.error('Error streaming deep analysis:', error);
        throw error;
    }
};

/**
 * Compare selected products
 * @param {Array} selectedProducts - Array of product objects with product_id
 * @returns {Promise<Object>} Comparison data
 */
export const compareProducts = async (selectedProducts) => {
    try {
        const productIds = selectedProducts.map(p => p.product_id);
        const response = await fetch(`${API_BASE_URL}/compare-products`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                selected_products: productIds
            })
        });

        if (!response.ok) {
            throw new Error(`Failed to compare products: ${response.status}`);
        }

        const responseData = await response.json();

        // Extract the comparison_report from the nested response structure
        // External API returns: { status: "success", data: { comparison_report: {...} } }
        if (responseData.data && responseData.data.comparison_report) {
            return responseData.data.comparison_report;
        }

        // Fallback for direct response (if structure changes)
        return responseData;
    } catch (error) {
        console.error('Error comparing products:', error);
        throw error;
    }
};

/**
 * Fetch final analysis report
 * @param {string} analysisId - Analysis ID from the backend
 * @returns {Promise<Object>} Final analysis report
 */
export const fetchAnalysisReport = async (analysisId) => {
    try {
        console.log('API: Fetching analysis report from backend:', analysisId);

        const response = await fetch(`${API_BASE_URL}/analysis-report/${analysisId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch analysis report: ${response.status}`);
        }

        const reportData = await response.json();
        console.log('API: Analysis report fetched successfully');
        return reportData;
    } catch (error) {
        console.error('Error fetching analysis report:', error);
        throw error;
    }
};
